import React from 'react';
import { StyleSheet, ActivityIndicator } from 'react-native';

import { ListItem, Image } from '@rneui/themed';
import { useLanguage } from '../context/LanguageContext';

const styles = StyleSheet.create({
    item: {
        width: '80%',
        justifyContent: 'center',
        alignSelf: 'center',
    },
    content: {
        width: '80%',
        justifyContent: 'center',
        alignSelf: 'center',
    },
    imageContent: {
        aspectRatio: 1,
        width: '80%',
        justifyContent: 'center',
    },
    touchContent: {
        width: '100%',
    },
});

interface ItemProps {
    item: {
        type_id: string;
        name: string;
        description: string;
        image: string;
    };
}

const Item: React.FC<ItemProps> = ({ item }) => {
    const { currentLanguage } = useLanguage();
    return (
        <>
            <ListItem.Title>{item.name[currentLanguage]}</ListItem.Title>
            <ListItem.Subtitle>
                {item.description[currentLanguage]}
            </ListItem.Subtitle>
            <Image
                source={{ uri: item.image }}
                containerStyle={styles.imageContent}
                PlaceholderContent={<ActivityIndicator />}
            />
        </>
    );
};

export default Item;
